import slugify from 'slugify';

export const basicSlugify = (value?: string): string => slugify(value || '', { lower: true, strict: true });
